;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';
	
	var Collection = APP.module('Collection');
	var Model      = APP.module('Model');
	
	Collection.TippingLeagues =  Collection.Leagues.extend({
		model: Model.TippingLeague,
		api_prefix: 'tipping'
	});

}(window, APP, Backbone, Marionette, $, _));